import { Mail, MailWarning } from "lucide-react";

const MESSAGES = {
  pending: "Your order email is awaiting sending.",
  sending: "Your order email is being submitted.",
  accepted: "Order confirmation submitted to your account email.",
  failed: "Your order is saved, but the confirmation email could not be sent.",
  unknown: "Your order is saved. Email status could not be confirmed.",
  not_requested: "Guest order — no email confirmation requested.",
};

export const OrderEmailNotice = ({ status }) => {
  if (!status) return null;
  const state = status.customer;
  const Icon = ["failed", "unknown"].includes(state) ? MailWarning : Mail;
  return (
    <div className="mt-5 flex items-start gap-2 border-t border-cream-muted pt-4 text-left text-xs text-muted-foreground" role="status" data-testid="order-email-notice">
      <Icon className="mt-0.5 h-4 w-4 shrink-0 text-ragi" aria-hidden="true" />
      <p className="min-w-0 break-words" data-testid="order-email-status">{MESSAGES[state] || "Email status unavailable."}</p>
    </div>
  );
};